import React from 'react';
import { Text, Button } from '@geist-ui/core';
import { 
  GiPlayButton, 
  GiPauseButton, 
  GiSpeaker 
} from 'react-icons/gi';
import './MusicPlayer.css';

const MusicModal = ({ 
  isOpen, 
  onClose, 
  tracks, 
  currentTrack, 
  isPlaying, 
  volume, 
  onSelectTrack, 
  onTogglePlay, 
  onVolumeChange 
}) => {
  if (!isOpen) return null;

  const handleVolumeChange = (e) => {
    onVolumeChange(parseFloat(e.target.value));
  };

  return (
    <div className="music-modal-overlay" onClick={onClose}>
      <div className="music-modal-content" onClick={e => e.stopPropagation()}>
        <Text h2>Background Music</Text>
        
        <div className="volume-control">
          <div 
            className="volume-play-button"
            onClick={onTogglePlay}
          >
            {isPlaying ? <GiPauseButton /> : <GiPlayButton />}
          </div>
          <GiSpeaker />
          <input
            type="range"
            min="0"
            max="1"
            step="0.01"
            value={volume}
            onChange={handleVolumeChange}
            className="volume-slider"
          />
        </div>
        
        <div className="tracks-container">
          <div className="track-list">
            {tracks.map(track => (
              <div 
                key={track.id} 
                className={`track-item ${currentTrack.id === track.id ? 'active' : ''}`}
                onClick={() => onSelectTrack(track)}
              >
                <div className="track-info">
                  <span className="track-title">{track.title}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="modal-footer">
          <Button onClick={onClose} className="theme-button">Close</Button>
        </div>
      </div>
    </div>
  );
};

export default MusicModal;